import { NearbyTheatreContainer } from "./FindNearbyTheatre.styles";

const FindNearbyTheatre = ({ cityJson }: any) => {
  const handleBookNow = () => {
    //navigate("private-theaters-booking");
    const element = document.getElementById("our-branches");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" }); // Scroll smoothly to the section
    }
  };

  return (
    <>
      <NearbyTheatreContainer>
        <h1 className="title">
          {cityJson.name === "Mumbai" ? (
            <>
              <span>Aamchi Mumbai, Your Private Theatre</span>
              <br /> <span>Experience is Coming Soon</span>
            </>
          ) : cityJson.name === "Chennai" ? (
            <>
              <span>Vanakkam Chennai! Private Theatre</span>
              <br />
              <span>Celebrations Arriving Soon</span>
            </>
          ) : (
            <>
              <span>Celebrate in Style at {cityJson.name}'s</span>
              <br /> <span>Best Private Theaters</span>
            </>
          )}
        </h1>
        <h2 className="subtitle">
          {cityJson.name === "Mumbai" ? (
            <>
              <span>
                Escape the city's hustle and celebrate your special moments in
                style. The Binge Town brings you exclusive private theatres for
                unforgettable gatherings.
              </span>
            </>
          ) : cityJson.name === "Chennai" ? (
            <>
              <span>
                Experience the joy of personalised celebrations. Whether it's a
                birthday or an anniversary, The Binge Town offers intimate
                private theatres for your memorable events.
              </span>
            </>
          ) : (
            <>
              <span> Choose from multiple branches across {cityJson.name}</span>
              <br /> <span>for unforgettable celebrations</span>
            </>
          )}
        </h2>
        {cityJson.name === "Mumbai" || cityJson.name === "Chennai" ? (
          <span onClick={handleBookNow} className="findButton">
            Join our waitlist
          </span>
        ) : (
          <a onClick={handleBookNow} className="findButton">
            Find Your Nearest Theatre
          </a>
        )}
      </NearbyTheatreContainer>
      {cityJson.name === "Mumbai" || cityJson.name === "Chennai" ? (
        <span onClick={handleBookNow} className="findButton_mobile">
          Join our waitlist
        </span>
      ) : (
        <div onClick={handleBookNow} className="findButton_mobile">
          Find Your Nearest Theatre
        </div>
      )}
    </>
  );
};

export default FindNearbyTheatre;
